export default __webpack_public_path__ + "static/media/partly-cloudy-day.fb0c7835.svg";